<div class="login-container">
  <!-- A newer Link is out: the Link icon at the top left, one tap loads it -->
  <app-update-button [corner]="true"></app-update-button>
  <!-- Left Panel - Branding -->
  <div class="login-panel login-panel--left">
    <img src="../../../assets/login/ring-left.png" class="login-panel__ring-left" alt="" />
    <img src="../../../assets/login/folded-ring.png" class="login-panel__ring-folded" alt="" />

    <div class="login-panel__content">
      <img src="../../../assets/login/computer-system.png" class="login-panel__image" alt="" />

      <div class="login-panel__header">
        <div class="login-panel__animated">
          <p class="login-panel__animated-text">LINK</p>
          <p class="login-panel__animated-text login-panel__animated-text--delay">
            Stay Connected, Get Things Done
          </p>
        </div>
        <p class="login-panel__description">
          Your go-to place for chatting, sharing updates, and collaborating with the team.
        </p>
      </div>
    </div>
  </div>

  <!-- Right Panel - Login Form -->
  <div class="login-panel login-panel--right">
    <div class="login-form">
      <!-- Logo -->
      <div class="login-form__logo">
        <img src="../../../assets/login/link-logo.png" alt="Link Logo" />
      </div>

      <!-- Step 1: Credentials Form -->
      @if (step === 'credentials') {
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="login-form__content">
        <div class="login-form__group">
          <input formControlName="username" type="text" id="username" placeholder="Enter Username"
            class="login-form__input" (click)="onInputClick()" autocomplete="username" />
        </div>

        <div class="login-form__group login-form__group--password">
          <input [type]="showPassword ? 'text' : 'password'" formControlName="password" id="password"
            placeholder="Enter Password" class="login-form__input" (input)="onPasswordInputChange()"
            (click)="onInputClick()" autocomplete="current-password" />

          @if (passwordNotEmpty) {
          <button type="button" class="login-form__password-toggle" (click)="togglePasswordVisibility()" tabindex="-1"
            aria-label="Toggle password visibility">
            @if (!showPassword) {
            <span class="material-symbols-outlined">visibility</span>
            }
            @if (showPassword) {
            <span class="material-symbols-outlined">visibility_off</span>
            }
          </button>
          }
        </div>

        <!-- Error Message -->
        @if (errorMessage) {
        <div class="login-form__error">
          <span class="material-symbols-outlined">error</span>
          <span>{{ errorMessage }}</span>
        </div>
        }

        <!-- Submit Button -->
        <div class="login-form__group">
          <button type="submit" class="login-form__button" [disabled]="isLoggingIn">
            @if (!isLoggingIn) {
            <span>Login</span>
            }
            @if (isLoggingIn) {
            <div class="login-form__spinner"></div>
            }
          </button>
        </div>
      </form>
      }

      <!-- Step 2: OTP Verification Form -->
      @if (step === 'otp') {
      <div class="login-form__content login-form__content--otp">
        <div class="login-form__otp-header">
          <h2 class="login-form__otp-title">Two-Step Verification</h2>
          <p class="login-form__otp-subtitle">
            Enter the 6-digit code sent to
            <span class="login-form__otp-email">{{ maskedEmail || 'your registered email' }}</span>
          </p>
        </div>

        <div class="login-form__group">
          <input type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6"
            placeholder="Enter 6-digit OTP" class="login-form__input login-form__input--otp"
            [value]="otpValue" (input)="onOtpInput($event)" (keydown)="onOtpKeyDown($event)"
            (paste)="onOtpPaste($event)" (click)="onInputClick()" (keyup.enter)="onVerifyOtp()"
            id="otp-input" autofocus />
        </div>

        <!-- Error Message -->
        @if (errorMessage) {
        <div class="login-form__error">
          <span class="material-symbols-outlined">error</span>
          <span>{{ errorMessage }}</span>
        </div>
        }

        <!-- Verify Button -->
        <div class="login-form__group">
          <button type="button" class="login-form__button" (click)="onVerifyOtp()"
            [disabled]="isLoggingIn || otpValue.length !== 6">
            @if (!isLoggingIn) {
            <span>Verify & Log In</span>
            }
            @if (isLoggingIn) {
            <div class="login-form__spinner"></div>
            }
          </button>
        </div>

        <!-- Resend and Back Actions -->
        <div class="login-form__otp-actions">
          <div class="login-form__resend-wrapper">
            @if (resendCountdown > 0 && !canResend) {
            <span class="login-form__resend-countdown">
              Resend code in {{ resendCountdown }}s
            </span>
            }
            @if (resendCountdown === 0 || canResend) {
            <button type="button" class="login-form__link-btn" (click)="onResendOtp()" [disabled]="isLoggingIn">
              Resend OTP
            </button>
            }
          </div>

          <div class="login-form__back-wrapper">
            <button type="button" class="login-form__link-btn login-form__link-btn--secondary"
              (click)="onBackToCredentials()" [disabled]="isLoggingIn">
              Use a different account
            </button>
          </div>
        </div>
      </div>
      }

      <!-- Company Logo -->
      <div class="login-form__company-logo">
        <img src="../../../assets/login/company-grouped-logo.png" alt="Company Logo" />
      </div>
    </div>
  </div>
</div>

<!-- Loading Overlay -->
@if (isLoading) {
<div class="login-loader">
  <div class="login-loader__spinner"></div>
</div>
}

<!-- Bottom Left Version Display -->
@if (version) {
<div class="login-version">
  <span>{{ version }}</span>
</div>
}